'use strict'
const currency = require('usd-formatter')
const Opentip = require('opentip/downloads/opentip-native.js')
const cartAnimationDuration = 500

const cartElementAnimationDelay = 300
const cartTipDelay = 3000
const openTipStyles = {
	background: '#fff',
	closeButtonCrossColor: '#000',
	borderColor: '#000',
	shadow: true,
	borderWidth: 2,
	borderRadius: 0,
	closeButtonCrossLineWidth: 1,
	closeButtonRadius: 12,
	closeButtonCrossSize: 7,
	className: 'cartTip'

}
for(let i in openTipStyles){
	Opentip.styles.standard[i] = openTipStyles[i]
}

const cartIco = document.querySelector('.cartIco')
let cartEl
let prodEl
let listEl
let formEl
let totalEl
let totalPriceEl
let cartTip
let closeTipTimeout

// If cart exists, attach events
if(cartIco){
	cartEl = document.querySelector('.cart')
	formEl = cartEl.querySelector('form')
	totalEl = cartIco.querySelector('span')
	listEl = cartEl.querySelector('.list')
	prodEl = listEl.querySelector('.prod')
	totalPriceEl = cartEl.querySelector('.total div:nth-of-type(2)')
	cartTip = new Opentip('.cartTip', 'Content stuff', {
		target: '.cartIco',
		hideTriggers: ['tip', 'target']
	})
	cartIco.addEventListener('click', e => {
		e.preventDefault()
		main.open()
	})
	// Hide cart actions
	cartEl.addEventListener('click', hideCart)
	cartEl.querySelector('.close').addEventListener('click', hideCart)
	cartEl.querySelector('.keep').addEventListener('click', hideCart)
	cartEl.querySelector('.cont').addEventListener('click', e => {
		e.stopPropagation()
	})
}
function hideCart(e){
	e.preventDefault()
	main.close()
}


// Dynamic elements
function updateCartTotal(total){
	// Update cart total
	totalEl.textContent = total
	if(total === 0){
		formEl.classList.add('empty')
		cartIco.classList.remove('active')
	}
	else{
		formEl.classList.remove('empty')
		cartIco.classList.add('active')
	}
}
function createCartElement(obj){
	const el = prodEl.cloneNode(true)
	el.dataset.id = obj.id
	el.querySelector('a').setAttribute('href', `/product/${obj.id}`)
	el.querySelector('img').setAttribute('src', obj.img)
	el.querySelector('.name').textContent = obj.name
	const qty = el.querySelector('.qty')
	qty.setAttribute('name', `qty-${obj.id}`)
	qty.value = obj.qty || 1
	el.querySelector('.del input').setAttribute('name', `delete-${obj.id}`)
	el.querySelector('.price').textContent = `$${obj.price}`
	listEl.appendChild(el)
	setTimeout(() => el.classList.add('show'), 100)
}
function removeCartElement(el){
	el.classList.remove('init')
	el.classList.remove('show')
	el.classList.add('hide')
	setTimeout(() => {
		listEl.removeChild(el)
	}, cartElementAnimationDelay)
}
function showTip(name){
	// Show tip if cart is closed
	if(!main.isOpen){
		cartTip.setContent(`"${name}" was added to your cart.`)
		cartTip.show()
		clearTimeout(closeTipTimeout)
		closeTipTimeout = setTimeout(main.closeTip, cartTipDelay)
	}
}







const main = module.exports = {
	closeTip: function(){
		cartTip.hide()
	},
	open: function(){
		main.closeTip()
		//cartEl.style.display = 'block'
		//setTimeout(() => cartEl.classList.add('show'), 100)
		this.isOpen = true
		cartEl.style.display = 'block'
	},
	close: function(){
		//cartEl.classList.remove('show')
		//setTimeout(() => cartEl.style.display = 'none', cartAnimationDuration)
		this.isOpen = false
		cartEl.style.display = 'none'
	},
	update(arr){
		const els = [].slice.call(listEl.querySelectorAll('.prod'))
		els.shift()
		const ids = []
		let totalQty = 0
		let totalPrice = 0
		for(let i = arr.length; i--;){
			ids.push(arr[i].id)
			totalQty += arr[i].qty
			totalPrice += (arr[i].price * arr[i].qty)
		}

		// Remove cart els that shouldn't exist
		for(let i = els.length; i--;){
			if(ids.indexOf(els[i].dataset.id) === -1){
				removeCartElement(els[i])
				els.splice(i, 1)
			}
		}


		for(let i = 0; i < arr.length; i++){
			const el = listEl.querySelector(`[data-id="${arr[i].id}"]`)
			// Create new cart element
			if(!el){
				createCartElement(arr[i])
				showTip(arr[i].name)
			}
			// Update quantity
			else{
				const qty = el.querySelector('.qty')
				if(qty.value != arr[i].qty){
					qty.value = arr[i].qty
					showTip(arr[i].name)
				}
			}
		}

		// Update totals
		updateCartTotal(totalQty)
		totalPriceEl.textContent = currency(totalPrice, {
			decimalSize: 2
		})



	}
}